export const deviceOffsetFieldKeysMap = new Map([
    ['temperature', 'Temperature'],
    ['pressure', 'Pressure'],
    ['humidity_offset', 'Humidity Add'],
    ['humidity', 'Humidity Mult'],
]);
